<template>
  <div>
    <div class="row align-items-end">
      <div class="col-3">
        <label for="">Produit</label>
        <select v-model="raw_material_item.fullName" class="form-select">
          <option
            v-for="(item, index) in items"
            :key="index++"
            :value="item.fullName"
          >
            {{ item.fullName }}
          </option>
        </select>
      </div>
 
      <div class="col-2">
        <label for="">Prix </label>
        <input
          type="text"
          v-model="raw_material_item.priceTTC"
          class="form-control"
        />
      </div>

      <div class="col-2">
        <label for="">Quantité </label>
        <input
          type="text"
          v-model="raw_material_item.quantity"
          class="form-control"
        />
      </div>

      <div class="col-2">
        <label for="">Quantité (U*)</label>
        <input
          type="text"
          v-model="raw_material_item.quantityUnit"
          class="form-control"
        />
      </div>

      <div class="col-auto">
        <label for=""></label>
        <button class="btn btn-success" @click="save(raw_material_item)">
          <i class="bi bi-plus-circle"></i> Insérer
        </button>
      </div>

      <div class="col-auto">
        <button
          class="btn btn-secondary d-flex align-items-center"
          @click="refresh()"
        >
          <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
          <span> Actualiser </span>
        </button>
      </div>
    </div>

    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix </th>
          <th scope="col">Quantité</th>
          <th scope="col">Quantité </th>
          <th scope="col">Montant Total</th>
          <th scope="col">Créer par</th>
          <th scope="col"></th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in purchase_items" :key="index++">
          <td>
            {{ index }}
          </td>

          <td>
            <span v-if="item">
              {{ item.name }}
            </span>
          </td>

          <td class="text-info">
            <span v-if="item.priceTTC != null">
              {{ item.priceTTC }}
            </span>
          </td>

          <td class="text-warning">
            <span v-if="item.quantity != null">
              {{ item.quantity }}
            </span>
          </td>

          <td class="text-warning">
            <span v-if="item.quantityUnit != null">
              {{ item.quantityUnit }}
            </span>
          </td>

          <td class="text-info">
            <span v-if="item.totalPriceTTC != null">
              {{ item.totalPriceTTC }}
            </span>
          </td>

          <td>
            <span v-if="item.user">
              {{ item.user.name }}
            </span>
          </td>

          <td class="d-flex">
            <button @click="remove(item.id)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
            <button class="btn text-secondary">
              <i class="bi bi-pencil-square"></i>
            </button>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr class="border-0">
          <td></td>

          <td>Total :</td>
          <td class=""></td>
          <td>
            <span
              v-if="totalQuantityItems != null"
              class="fw-bold bg-warning px-2 py-1 rounded"
            >
              {{ totalQuantityItems }}
            </span>
          </td>
          <td>
            <span
              v-if="totalPriceTTCItems != null"
              class="fw-bold bg-warning px-2 py-1 rounded"
            >
              {{ totalPriceTTCItems }}
            </span>
            DH
          </td>

          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <br />

    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-8">
      
      </div>
      <div class="col-auto">
        <button
          class="btn btn-success"
          @click="validated()"
          
        >
          <i class="bi bi-check-square-fill"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      raw_material_item: {},
      section_reference: "",
      accept: false,
      items: [{ fullName: "Poulet" }, { fullName: "Dinde" }],
    };
  },
  computed: {
    ...mapGetters("rawMaterial", {
      purchase_items: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      numberItems: "numberItems",
    }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("rawMaterial/storeItem", data);
      await (this.purchase_item = {});
    },

    async remove(id) {
      await this.$store.dispatch("rawMaterial/deleteItem", id);
    },

    async refresh() {
      this.$store.dispatch("rawMaterial/getAllItems");
    },
    async validated() {
      this.$router.push({ name: "raw-materials-create" });
    },
  },
  beforeMount() {
    this.$store.dispatch("rawMaterial/getAllItems");
  },
};
</script>
